import React from 'react'
import { Row, Switch } from 'antd'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

interface Props {
  defaultValue: boolean
  onChange: (checked: boolean) => void
}

const LegalFormalities = (props: Props): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <br />
      <h4>{t('legalFormalities.label')}</h4>
      <Row align="middle">
        <span>{t('no')}</span>
        <Switch
          checked={sessionStorage.getItem('withLegalFormality') === 'true'}
          onChange={(checked: boolean) => {
            props.onChange(checked)
            sessionStorage.setItem('withLegalFormality', `${checked}`)
          }}
        />
        <span>{t('yes')}</span>
      </Row>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-bottom: 17px;

  label {
    display: block;
  }

  span {
    margin-left: 10px;
    margin-right: 10px;
  }
`

export default LegalFormalities
